const generateSrcset = (image, widths = []) => {
	  const imageUrl = new URL(image["src"]);
	    return widths
		    .filter((width) => width <= image["width"])
			    .map((width) => {
				      imageUrl.searchParams.set("width", width.toString());
					        return imageUrl.href + " " + width + "w";
							    })
								    .join(", ");
									};

									const createImageElement = (image, classes, sizes, productTitle) => {
									  const previewImage = image["preview_image"];
									    const newImage = new Image(previewImage["width"], previewImage["height"]);
										  newImage.className = classes;
										    newImage.alt = image["alt"] || productTitle;
											  newImage.sizes = sizes;
											    newImage.src = previewImage["src"];
												  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
												    newImage.loading = "lazy";
													  return newImage;
													  };

													  const swapCardImage = (input) => {
													    const wrapper = input.closest(".js-color-swatches-wrapper");
														  if (!wrapper) return;
														    const primaryImage = wrapper.querySelector(".media--first");
															  const secondaryImage = wrapper.querySelector(".media--second");
															    const handleProduct = wrapper.dataset.product;
																  if (!input.checked || !primaryImage) return;
																    wrapper.querySelectorAll(".js-color-swatches-link").forEach((item) => item.setAttribute("href", input.dataset.variantLink));
																	  const currentColor = input.value;
																	    fetch(window.Shopify.routes.root + "products/" + handleProduct + ".js").then((r) => r.json()).then(function (product) {
																		    const variant = product.variants.filter((item) => item.featured_media != null && item.options.includes(currentColor))[0];
																			    if (!variant) return;
																				    const newPrimaryImage = createImageElement(variant.featured_media, primaryImage.className, primaryImage.sizes, product.title);
																					    if (newPrimaryImage.src === primaryImage.src) return;
																						    let flag = false;
																							    if (secondaryImage) {
																								      const secondaryImagePathname = new URL(secondaryImage.src).pathname;
																									        const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;
																											      if (secondaryImagePathname == newPrimaryImagePathname) {
																												          primaryImage.remove();
																														          secondaryImage.classList.remove("media--second");
																																          secondaryImage.classList.add("media--first");
																																		          flag = true;
																																				        }
																																						    }
																																							    if (flag == false) {
																																								      primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" });
																																									        setTimeout(function () {
																																											        primaryImage.replaceWith(newPrimaryImage);
																																													        newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
																																															        if (secondaryImage) secondaryImage.remove();
																																																	      }, 200);
																																																		      }
																																																			    }).catch(function () {});
																																																				};

																																																				document.addEventListener("click", function (event) {
																																																				  const input = event.target.closest(".js-color-swatches input");
																																																				    if (input) swapCardImage(input);
																																																					});

																																																					document.addEventListener("change", function (event) {
																																																					  const input = event.target.closest(".js-color-swatches input");
																																																					    if (input) swapCardImage(input);
																																																						});
																																																						
